var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpushopened(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.800781,
    width: 43.4019,
    height: 43.4019,
    rx: 6,
    fill: "#FEEFFA"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_18238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_18238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 21,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6719 13.6133H32.6719V31.3911H12.6719V13.6133Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_18238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6719 19.0473C22.4879 19.0498 22.305 19.064 22.1233 19.0899C21.9416 19.1157 21.7628 19.153 21.5871 19.2016C21.6684 19.3286 21.7303 19.4628 21.7729 19.6039C21.8155 19.7451 21.8374 19.8888 21.8385 20.0349C21.8385 20.5122 21.6487 20.9196 21.269 21.2571C20.8893 21.5946 20.431 21.7633 19.8941 21.7633C19.7297 21.7623 19.568 21.7429 19.4092 21.705C19.2504 21.6672 19.0995 21.6121 18.9566 21.5399C18.6398 22.5165 18.7812 23.4375 19.3808 24.303C19.9803 25.1685 20.842 25.6953 21.9657 25.8834C23.0894 26.0715 24.1076 25.8594 25.0203 25.247C25.933 24.6347 26.4416 23.8225 26.5462 22.8103C26.6507 21.7982 26.317 20.9172 25.545 20.1674C24.7731 19.4176 23.8153 19.0442 22.6719 19.0473ZM32.551 22.0534C30.6681 18.7877 26.9403 16.5781 22.6719 16.5781C18.4035 16.5781 14.6746 18.7892 12.7927 22.0537C12.7121 22.1954 12.6719 22.3455 12.6719 22.5042C12.6719 22.6629 12.7121 22.813 12.7927 22.9547C14.6757 26.2204 18.4035 28.43 22.6719 28.43C26.9403 28.43 30.6691 26.2189 32.551 22.9544C32.6316 22.8127 32.6719 22.6626 32.6719 22.5039C32.6719 22.3452 32.6316 22.1951 32.551 22.0534ZM22.6719 26.9485C19.2465 26.9485 16.1062 25.251 14.4104 22.5041C16.1062 19.7571 19.2462 18.0596 22.6719 18.0596C26.0976 18.0596 29.2375 19.7571 30.9333 22.5041C29.2379 25.251 26.0976 26.9485 22.6719 26.9485Z",
    fill: "#F661CF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_18238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white",
    transform: "translate(12.6719 13.6133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpushopened);
export default __webpack_public_path__ + "static/media/fullpushopened.ed6bf367b6f470dd0c5dd1dfed67754d.svg";
export { ForwardRef as ReactComponent };